export default __webpack_public_path__ + "static/media/srt_logo.69a14569.png";